import usePointFindBy from "features/points/hooks/usePointFindBy";
import PointInfo from "../PointInfo/PointInfo";
import NothingToShow from "ui/common/components/feedback/NothingToShow/NothingToShow";

const PointList = () => {
    const { data, isLoading } = usePointFindBy();

    const nothingToShow = !isLoading && !data;

    return nothingToShow ? <NothingToShow /> : <PointInfo isLoading={isLoading} data={data} />;
};

export default PointList;
